export default __webpack_public_path__ + "static/media/5.BODEGA_REFRIGERADA.8475afc2.jpg";